const CAR_CONFIG = {
  width: 56,
  height: 18,
  startX: 60,
}

const PHYSICS_CONFIG = {
  groundPadding: 18,
  gravity: 2000,
  gravityHoldDescend: 500,
  jumpVelocity: -520,
  maxJumpHoldMs: 2000,
  initialSpeed: 245,
  speedIncrement: 7,
  minSafeDistancePx: 210,
  minGapPx: 150,
  airGroundSafeGapPx: 140,
}

const SPAWN_CONFIG = {
  initialCooldown: 0,
  initialNextSpawn: 1.2,
  earlyGameScoreThreshold: 35,
}

export { CAR_CONFIG, PHYSICS_CONFIG, SPAWN_CONFIG }
